/**
 * @description 去除字符串两侧空格
 * @param string value
 * @returns {boolean}
 */
export function trim(value) {
  const reg = /(^\s*)|(\s*$)/g;
  return value.replace(reg, "");
}

/**
 * @description 去除字符串左侧空格
 * @param string value
 * @returns {boolean}
 */
export function ltrim(value) {
  const reg = /(^\s*)/g;
  return value.replace(reg, "");
}

/**
 * @description 去除字符串右侧空格
 * @param string value
 * @returns {boolean}
 */
export function rtrim(value) {
  const reg = /(\s*$)/g;
  return value.replace(reg, "");
}